"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbStringToNum = exports.numToRgbString = void 0;
function numToRgbString(num) {
    return `${(num >> 16) & 255},${(num >> 8) & 255},${num & 255}`;
}
exports.numToRgbString = numToRgbString;
function rgbStringToNum(str) {
    const [r, g, b] = str.split(",");
    return (parseInt(b, 10) << 0) | (parseInt(g, 10) << 8) | (parseInt(r, 10) << 16);
}
exports.rgbStringToNum = rgbStringToNum;
